/* eslint-disable no-secrets/no-secrets */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierSW-react/config/PremierSW-wizard-config.json5";
import metadata from './BeaSpaAndWellPage.metadata.json5';
import styles from '../../SpaAndWellCommonStyles.module.scss'
import ProductsandCoverageSelection from '../../components/BeaSpaAndWell/ProductsandCoverageSelection/ProductsandCoverageSelection';
import BusinessInformation from '../../components/BeaSpaAndWell/BusinessInformation/BusinessInformation';
import HairdressingandBeauticians from '../../components/BeaSpaAndWell/HairdressingandBeauticians/HairdressingandBeauticians';
import Operations from '../../components/BeaSpaAndWell/Operations/Operations';
import Massage from '../../components/BeaSpaAndWell/Massage/Massage';
import AdditionalInformation from '../../components/BeaSpaAndWell/AdditionalInformation/AdditionalInformation';
import TanningSalon from '../../components/BeaSpaAndWell/TanningSalon/TanningSalon';
import Laser from '../../components/BeaSpaAndWell/Laser/Laser';
import Teaching from '../../components/BeaSpaAndWell/Teaching/Teaching';
import TeethWhitening from '../../components/BeaSpaAndWell/TeethWhitening/TeethWhitening';
import Cyber from '../../components/BeaSpaAndWell/Cyber/Cyber';

function BeaSpaAndWellPage(props) {


    const { wizardData: submissionVM, updateWizardData, steps, changeNextSteps } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const offPath = 'lobData.spaAndWellLine.coverables.beauticiansSpa'
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'))
    const propertyCoverageSteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('propertyCoverages'))

    const {
        onValidate,
        initialValidation
    } = useValidation('BeaSpaAndWellPage');


    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {
            const proCov = _.get(submissionVM.value, 'lobData.spaAndWellLine.coverables.beauticiansSpa.productsandCoverageSelection.proFie');
            const isProductCoverageSelected = !_.isUndefined(proCov) && proCov;

            if (isProductCoverageSelected) {
                let newSteps = steps;

                const liabilityCoveragesIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                const propertyIndex = steps.findIndex((step) => step.id === "property");

                if (propertyIndex < 0) {
                    steps.splice(liabilityCoveragesIndex + 1, 0, propertySteps[0]);
                }

                const propertyCoverageIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if (propertyCoverageIndex < 0) {
                    steps.splice(liabilityCoveragesIndex + 2, 0, propertyCoverageSteps[0]);
                }

                newSteps = steps.slice(liabilityCoveragesIndex);

                changeNextSteps(newSteps);

            } else {
                let newSteps = steps;

                const propertyIndex = steps.findIndex((step) => step.id === "property");

                if (propertyIndex >= 0) {
                    steps.splice(propertyIndex, 1);
                }

                const propertyCoverageIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if (propertyCoverageIndex >= 0) {
                    steps.splice(propertyCoverageIndex, 1);
                }

                const liabilityCoveragesIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                newSteps = steps.slice(liabilityCoveragesIndex);

                changeNextSteps(newSteps);
            }

            const { productCode } = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'BeaSpaAndWellPage', submissionVM);

            return submissionVM;

        },
        [submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.spaAndWellLine.coverables.beauticiansSpa.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'BeaSpaAndWellPage', subVMCopy);
                            
            return submissionVM;
        },
        [submissionVM]
    );

    const overrideProps = {
        productCoverageSelectionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.productsandCoverageSelection`
        },
        businessInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.businessInformation`
        },
        hairdressingandBeauticiansComponent: {
            visible: _.get(submissionVM, `${offPath}.productsandCoverageSelection.proReqFie.value.code`) === 'HaiBea',
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.hairdressingandBeauticians`
        },
        operationsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.operations`
        },
        additionalInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.additionalInformation`
        },
        massageComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.massage`,
            visible: _.get(submissionVM, `${offPath}.additionalInformation.masRegFie.value`) !== undefined && _.get(submissionVM, `${offPath}.additionalInformation.masRegFie.value`),
        },
        tanningSalonComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.tanningSalon`,
            visible: _.get(submissionVM, `${offPath}.additionalInformation.tanBedBooFie.value`) !== undefined && _.get(submissionVM, `${offPath}.additionalInformation.tanBedBooFie.value`),
        },
        laserComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.laser`,
            visible: _.get(submissionVM, `${offPath}.additionalInformation.lasTreFie.value`) !== undefined && _.get(submissionVM, `${offPath}.additionalInformation.lasTreFie.value`),
        },
        teachingComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.teaching`,
            visible: _.get(submissionVM, `${offPath}.additionalInformation.teaOpeFie.value`) !== undefined && _.get(submissionVM, `${offPath}.additionalInformation.teaOpeFie.value`),
        },
        teethWhiteningComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.teethWhitening`,
            visible: _.get(submissionVM, `${offPath}.additionalInformation.teewhiFie.value`) !== undefined && _.get(submissionVM, `${offPath}.additionalInformation.teewhiFie.value`),
        },
        cyberComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.cyber`,
            visible: _.get(submissionVM, `${offPath}.productsandCoverageSelection.cybLiaFie.value`) !== undefined && _.get(submissionVM, `${offPath}.productsandCoverageSelection.cybLiaFie.value`),
        },
    }

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelectionComponent: ProductsandCoverageSelection,
            businessInformationComponent: BusinessInformation,
            hairdressingandBeauticiansComponent: HairdressingandBeauticians,
            operationsComponent: Operations,
            additionalInformationComponent: AdditionalInformation,
            massageComponent: Massage,
            tanningSalonComponent: TanningSalon,
            laserComponent: Laser,
            teachingComponent: Teaching,
            teethWhiteningComponent: TeethWhitening,
            cyberComponent: Cyber

        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => !_.isUndefined(submissionVM.lobData) &&
        !submissionVM.lobData.spaAndWellLine.coverables.beauticiansSpa.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}


BeaSpaAndWellPage.propTypes = wizardProps;
export default withRouter(BeaSpaAndWellPage);
